import { useTranslation } from 'react-i18next'
import { useQueryClient } from '@tanstack/react-query'

import { DrawerStepperProgress } from '@mercai/clever'

import { QUERIES_ADMIN } from '@/services'

import { TransactionFormStep, TransactionOrderStep } from './components'

import type { TransactionDrawerFormProps } from './transaction-drawer-form.type'

export const TransactionDrawerForm = ({
  uuid,
  orderUuid,
  payer,
  isOpen,
  onHandleOpen,
  onSetUuid,
  hasOrderStep = true,
}: TransactionDrawerFormProps) => {
  const { t } = useTranslation('screenOrderCenterPage')
  const queryClient = useQueryClient()

  const onSuccessSubmit = () => {
    queryClient.invalidateQueries({
      queryKey: [QUERIES_ADMIN.TRANSACTION.module],
    })

    queryClient.invalidateQueries({
      queryKey: [QUERIES_ADMIN.ORDER_CENTER.module],
    })
  }

  const isNewRegister = !uuid

  return (
    <DrawerStepperProgress
      translations={{
        optional: '',
      }}
      initialStep={'root'}
      isOpen={isOpen}
      onHandleOpen={onHandleOpen}
      title={
        isNewRegister
          ? t('formTransactionCreateDrawerTitle')
          : t('formTransactionUpdateDrawerTitle')
      }
      description={t('formTransactionUpdateDrawerDescription')}
      totalSteps={hasOrderStep ? 2 : 1}
      steps={{
        root: {
          title: t('formTransactionStepFormTitle'),
          isOptional: false,
          backNavigate: 'root',
          component: ({ onNavigateToPreviousStep, onNavigateToNextStep }) => (
            <TransactionFormStep
              uuid={uuid}
              orderUuid={orderUuid}
              payer={payer}
              hasOrderStep={hasOrderStep}
              onHandleBack={onNavigateToPreviousStep}
              onSuccessSubmit={(transaction) => {
                onSetUuid?.(transaction?.uuid || '')

                if (transaction?.payer?.uuid && hasOrderStep) {
                  onNavigateToNextStep('order')
                } else {
                  onNavigateToPreviousStep()
                }

                onSuccessSubmit()
              }}
            />
          ),
        },
        order: {
          title: t('formTransactionStepOrderTitle'),
          description: t('formTransactionStepOrderDescription'),
          isOptional: false,
          backNavigate: 'root',
          component: ({ onNavigateToPreviousStep }) => (
            <TransactionOrderStep
              uuid={uuid}
              onHandleBack={onNavigateToPreviousStep}
              onSuccessSubmit={() => {
                onHandleOpen()
                onSuccessSubmit()
              }}
            />
          ),
        },
      }}
    />
  )
}
